/**
 * One control glyph, asked for in its TEXT form (R579).
 *
 * U+23EE ⏮, U+23ED ⏭, U+23F8 ⏸, U+23F9 ⏹ and U+25B6 ▶ all carry an emoji
 * form, and iOS and Android pick the colour emoji font for them by default.
 * So a control strip drew a mix of coloured emoji and text glyphs. The
 * variation selector U+FE0E asks for the text form, and it is inert on a
 * code point that has no emoji form. So every control strip runs EVERY
 * glyph through here, and no reader has to know which ones need it. The
 * replay film (R579) and the media player (R852) both build their
 * transport through this helper.
 */
export function textGlyph(glyph: string): string {
  return `${glyph}︎`;
}
